import { FieldText } from '@dixa/lib-shared-habla';
import { PureComponent } from 'react';
import * as React from 'react';

type PropsT = {
  name: string;
  value: string;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    key: string,
    value: string,
  ) => void;
};

export class RSFieldText extends PureComponent<PropsT> {
  constructor(props: PropsT) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e?: React.ChangeEvent<HTMLInputElement>) {
    if (!e) return;
    const { name, onChange } = this.props;
    const { value } = e.target;
    if (typeof value === 'string') {
      onChange(e, name, value);
    }
  }

  render() {
    const { name, value } = this.props;

    return (
      <FieldText
        placeholder="Enter a value"
        input={{ name, value, onChange: this.onChange }}
      />
    );
  }
}
